import { render, staticRenderFns } from "./userLink.vue?vue&type=template&id=180511f4&scoped=true&"
import script from "./userLink.vue?vue&type=script&lang=js&"
export * from "./userLink.vue?vue&type=script&lang=js&"
import style0 from "./userLink.vue?vue&type=style&index=0&id=180511f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180511f4",
  null
  
)

export default component.exports